import { Component, OnInit } from '@angular/core';
import { FastAPIService } from '../../service/fast-api.service';
import { first, filter, lastValueFrom, timeInterval } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService, TreeNode, TreeTableNode, PrimeIcons } from 'primeng/api';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';

import * as XLSX from 'xlsx';
export enum ScrapingStatus {
      FetchPending = 0,
      Fetching = 1,
      AnalysisPending = 2,
      Analyzing = 3,
      SentimentPending = 4,
      SentimentAnalyzing = 5,
      GeocodePending = 6,
      Geocoding = 7,
      SavePending = 8,
      Saving = 9,
      Saved = 10
    }

@Component({
  selector: 'app-web-scraping',
  templateUrl: './web-scraping.component.html',
  styleUrls: ['./web-scraping.component.scss']
})
export class WebScrapingComponent implements OnInit {
  background = "assets/web-scraping-component-images/background.svg";
  mainIcon = "assets/web-scraping-component-images/mainIcon.svg";
  deleteBtnIcon = "assets/web-scraping-component-images/delete.svg";
  createBtnIcon = "assets/web-scraping-component-images/add.svg";
  orderIcon = "assets/web-scraping-component-images/order.svg";
  upIcon = "assets/web-scraping-component-images/up.svg";
  downIcon = "assets/web-scraping-component-images/down.svg";
  viewBtnIcon = "assets/web-scraping-component-images/view.svg";
  viewBtnActiveIcon = "assets/web-scraping-component-images/viewActive.svg";
  checkBtnIcon = "assets/web-scraping-component-images/savePending.svg";
  checkBtnActiveIcon = "assets/web-scraping-component-images/checkActive.svg";
  toBeginningIcon = "assets/web-scraping-component-images/start.svg";
  nextIcon = "assets/web-scraping-component-images/next.svg";
  backIcon = "assets/web-scraping-component-images/back.svg";
  toLastIcon = "assets/web-scraping-component-images/last.svg";
  calenderIcon = "assets/web-scraping-component-images/calendar.svg";
  loadingIcon = "assets/web-scraping-component-images/loading.svg";
  fetchIcon = "assets/web-scraping-component-images/fetchIcon.svg";
  arrowRight = "assets/web-scraping-component-images/Arrow - Right 3.svg"
  restartIcon = "assets/web-scraping-component-images/restartBtn.svg"


  filterID: string = "";
  filterStartDate: string = "";
  filterEndDate: string = "";
  filterStatus: string = "";
  filterDataSource: string = "";
  scriptSelected: FormControl = new FormControl();
  accessToken: string = "";
  username: string = "";
  password: string = "";
  Hastag: string = "";
  scrapingTypeSelected: FormControl = new FormControl('');
  scriptStartPage: FormControl = new FormControl();
  scriptStopPage: FormControl = new FormControl();
  scriptDescription: FormControl = new FormControl('');
  paramForm: FormGroup = new FormGroup({});


  select_all: boolean = false;
  dialog_visible: boolean = false;
  goto_dialog_visible: boolean = false;
  forceSaveSolr: boolean = false;
  reverseId: boolean = false;
  reverseDate: boolean = false;
  reverseQuantity: boolean = false;
  requireAuthentication: boolean = false;

  pageSize: number = 10;
  currentPage: number = 1;
  totalPage: number = 0;
  gotoPage: number = this.currentPage;

  todayDate: Date = new Date();

  requestList: WebScrapingRequest[] = [];
  selectedRequestList: string[] = [];
  selectedAttemptList: string[] = [];
  displayRequestList: number[] = [];
  dataSourceList: any[] = [];
  filterStatusOption: string[] = ["Any", "Fetch Pending", "Fetching", "Analysis Pending", "Analyzing", "Sentiment Pending", "Sentiment Analyzing", "Geocode Pending", "Geocoding", "Save Pending", "Saving", "Saved"];
  filterDataSourceOption: string[] = ["Any"];
  scrapingTypes: string[] = ['News', 'Social Media', 'File'];
  pageSizeList: number[] = [10, 15, 20];
  fileScriptList: any[] = [];
  newsFieldsVar: NewsFields = new NewsFields()


  sortBy: number = -1;
  sortOrder: boolean = true;

  loading: boolean = false;

  getSortIcon(index: number) {
    if (index == this.sortBy) {
      if (this.sortOrder) {
        return this.downIcon;
      }
      else {
        return this.upIcon;
      }
    }
    else {
      return this.orderIcon;
    }
  }

  constructor(private fastService: FastAPIService, private messageService: MessageService, private confirmationService: ConfirmationService, private route: Router) {
    setInterval(() => { this.reload() }, 10000);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    await this.getRequestList();
    this.loading = false;

    this.todayDate = new Date();

    this.scrapingTypeSelected.valueChanges.subscribe((value: string) => {
      this.scriptSelected.setValue({})
      this.getScriptsList(value)
    })

    this.scriptSelected.valueChanges.subscribe(() => {
      this.username = "";
      this.password = "";
      this.accessToken = "";
      this.buildDynamicForm();
      this.addCrossFieldValidation()
    })





  }

  reload() {
    this.getRequestList();
  }

  buildDynamicForm() {
    if (this.scriptSelected.value?.Parameter) {
      const group: { [key: string]: FormControl } = {};
      for (let param of this.scriptSelected.value.Parameter) {
        const validators = [];

        if (param.require) validators.push(Validators.required);
        if (param.type === 'number') {
          if (param.min != null) validators.push(Validators.min(param.min));
          if (param.max != null && param.max > 0) validators.push(Validators.max(param.max));
        }

        const lowerName = param.Name.toLowerCase();
        let matched = ''
        if (this.scriptSelected.value && this.scrapingTypeSelected.value == this.scrapingTypes[0]) {
          for (let key in this.scriptSelected.value) {
            if (key.toLowerCase() === lowerName && param.type === 'string') {
              matched = this.scriptSelected.value[key]
              break
            }
          }
        }
        const value = matched ? matched : (param.type === 'number' ? undefined : '');
        group[param.Name] = new FormControl(value, validators);

      }
      this.paramForm = new FormGroup(group);
    }

  }

  getFormControl(controlName: string): FormControl {
    return this.paramForm.get(controlName) as FormControl;
  }

  addCrossFieldValidation() {
    if (!this.scriptSelected.value?.Parameter) return;
    const params = this.scriptSelected.value.Parameter;
    for (let param of params) {
      if (param.maxRangeFrom) {
        const thisControl = this.getFormControl(param.Name);
        const fromControl = this.getFormControl(param.maxRangeFrom);        // console.log("This control ", thisControl, fromControl)
        if (!thisControl || !fromControl) continue;

        thisControl.valueChanges.subscribe(() => {
          const a = thisControl.value;
          const b = fromControl.value;

          if (a != null && b != null && Math.abs(a - b) > param.maxRangeNum) {
            thisControl.setErrors({ ...(thisControl.errors || {}), maxRangeExceeded: true });
          } else {
            const errors = { ...(thisControl.errors || {}) };
            delete errors['maxRangeExceeded'];
            thisControl.setErrors(Object.keys(errors).length ? errors : null);
          }
        });
      }
    }
  }


  gettingRequest: Boolean = false;
  async getRequestList() {
    if (this.gettingRequest) return;
    this.gettingRequest = true
    this.requestList = [];
    const response = await lastValueFrom(this.fastService.getScrapingRequest(Math.max(this.getRequestBegin(), 0), this.pageSize));
    if (response.status_code == 404) return;

    this.totalPage = response.response.total;

    const requests: any[] = response.response.data;
    for (let request of requests) {
      if (!this.filterDataSourceOption.includes(request.Script ? request.Scripe : request.ScrapingScript)) this.filterDataSourceOption.push(request.Script ? request.Scripe : request.ScrapingScript);
      this.requestList.push(request)
    }

    this.getTreeNode();
  }

  onSelectAllClick() {

  }

  onClearClick() {
    this.filterID = "";
    this.filterStartDate = "";
    this.filterEndDate = "";
    this.filterStatus = "";
    this.filterDataSource = "";
  }

  async onApplyClick() {
    this.loading = true;
    await this.getRequestList();
    this.loading = false;

    this.currentPage = 1;

    if (this.filterID != "") {
      this.requestList = this.requestList.filter((request) => {
        return request.RequestID == this.filterID;
      });
    }

    if (this.filterDataSource != "" && this.filterDataSource != "Any") {
      this.requestList = this.requestList.filter((request) => {
        return request.ScrapingScript == this.filterDataSource;
      })
    }

    if (this.filterStartDate != "") {
      this.requestList = this.requestList.filter((request) => {
        return new Date(request.Date).getTime() >= new Date(this.filterStartDate).getTime();
      });
    }

    if (this.filterEndDate != "") {
      this.requestList = this.requestList.filter((request) => {
        return new Date(request.Date).getTime() <= new Date(this.filterEndDate).getTime() + 86399000;
      });
    }

    if (this.filterStatus != "" && this.filterDataSource != "Any") {
      this.requestList = this.requestList.filter((request) => {
        return this.filterStatusOption[request.Status + 1] == this.filterStatus;
      })
    }

    this.getTreeNode();
  }

  async onDeleteClick(node: any) {
    if (confirm("Do you want to delete the " + (node.hasChildren ? "request" : "attempt") + " ?")) {
      const response = await lastValueFrom(node.hasChildren ? this.fastService.removeScrapingRequest(node.RequestID) : this.fastService.removeScrapingAttempt(node.AttemptID));
      alert(response.message)
      await this.getRequestList();
    }
  }

  onCreateClick() {
    this.dialog_visible = true;
    this.forceSaveSolr = false;
    this.requireAuthentication = false;
    this.onRemove({});
    this.scrapingTypeSelected.setValue("");
    this.accessToken = ""
    this.scriptSelected.setValue({});
    this.scriptStartPage.setValue(1);
    this.scriptStopPage.setValue(1);
  }

  onIDOrderClick() {
    if (this.sortBy == 0) {
      this.sortOrder = !this.sortOrder;
    }
    else {
      this.sortBy = 0;
      this.sortOrder = true;
    }
    this.requestList.sort((a, b) => {
      if (!this.sortOrder) {
        return a.RequestID < b.RequestID ? 1 : -1;
      }
      else {
        return a.RequestID > b.RequestID ? 1 : -1;
      }
    })
  }

  onDateOrderClick() {
    if (this.sortBy == 1) {
      this.sortOrder = !this.sortOrder;
    }
    else {
      this.sortBy = 1;
      this.sortOrder = true;
    }
    this.requestList.sort((a, b) => {
      if (!this.sortOrder) {
        return a.Date < b.Date ? 1 : -1;
      }
      else {
        return a.Date > b.Date ? 1 : -1;
      }
    })

  }

  async getScriptsList(value: string) {
    this.dataSourceList = [];
    let response
    switch (value) {
      case this.scrapingTypes[0]: response = await lastValueFrom(this.fastService.getNewsScriptsList()); break;
      case this.scrapingTypes[1]: response = await lastValueFrom(this.fastService.getSocialMediaScriptsList()); break;
      default: break;
    }

    if (!response) return;
    this.dataSourceList = response.response.data;
    return this.dataSourceList;
  }

  onQuantityOrderClick() {
    if (this.sortBy == 2) {
      this.sortOrder = !this.sortOrder;
    }
    else {
      this.sortBy = 2;
      this.sortOrder = true;
    }
    this.requestList.sort((a, b) => {
      if (!this.sortOrder) {
        return a.TotalQty < b.TotalQty ? 1 : -1;
      }
      else {
        return a.TotalQty > b.TotalQty ? 1 : -1;
      }
    })
  }

  async onViewClick(node: any) {
    this.route.navigate(['/test', { id: node.AttemptID }]);
  }

  async onCheckClick(request: any) {
    const status = request.Status;

    if (request.Status % 2 == 1 || request.Status == ScrapingStatus.Saved) return;

    try {
      request.Status += 1;

      switch (status) {
        case ScrapingStatus.FetchPending: switch (request.ScrapingType) {
          case "News": this.fastService.approveNewsFetching(request.RequestID).subscribe(); break;
          case "Social-Media": this.fastService.approveSocialMediaFetching(request.RequestID).subscribe(); break;
          //Need to fix
          // case "File": this.fastService.uploadFile(this.newsFieldsVar["Topic_OD"]!).subscribe();break;
          default: break;
        }break;
        case ScrapingStatus.AnalysisPending: switch (request.ScrapingType) {
          case "News": this.fastService.approveNewsAnalyzing(request.RequestID).subscribe(); break;
          case "Social-Media": this.fastService.approveSocialMediaAnalyzing(request.RequestID).subscribe(); break;
          case "File": this.fastService.approveFileAnalyzing(request.RequestID).subscribe(); break;
          default: break;
        }break;
        case ScrapingStatus.SentimentPending: switch (request.ScrapingType) {
          case "News": this.fastService.approveNewsSentiment(request.RequestID).subscribe(); break;
          case "Social-Media": this.fastService.approveSocialMediaSentiment(request.RequestID).subscribe(); break;
          case "File": this.fastService.approveFileSentiment(request.RequestID).subscribe(); break;
          default: break;
        }break;
        case ScrapingStatus.GeocodePending: switch (request.ScrapingType) {
          case "News": this.fastService.approveNewsGeocoding(request.RequestID).subscribe(); break;
          case "Social-Media": this.fastService.approveSocialMediaGeocoding(request.RequestID).subscribe(); break;
          case "File": this.fastService.approveFileGeocoding(request.RequestID).subscribe(); break;
          default: break;
        }break;
        case ScrapingStatus.SavePending: switch (request.ScrapingType) {
          case "News": this.fastService.approveNewsSolrUpdate(request.RequestID).subscribe(); break;
          case "Social-Media": this.fastService.approveSocialMediaSolrUpdate(request.RequestID).subscribe(); break;
          case "File": this.fastService.approveFileSolrUpdate(request.RequestID).subscribe(); break;
          default: break;
        }break;
        default: break;
      }
    }
    catch (e) {
      console.log(e);
    }

    this.getRequestList();
  }

  async onRestartClick(request: any) {
    request.Status = 0;
    switch (request.ScrapingType) {
      case "News": await lastValueFrom(this.fastService.restartNewsRequest(request.RequestID)); break;
      case "Social-Media": await lastValueFrom(this.fastService.restartSocialMediaRequest(request.RequestID)); break;
      case "File": await lastValueFrom(this.fastService.restartFileRequest(request.RequestID)); break;
      default: break;
    }
    this.getRequestList();
  }

  getPopupText(status: number) {

    if (status % 2 == 1) return "Loading";

    if (status == ScrapingStatus.FetchPending) return "Approve Fetching";
    if (status == ScrapingStatus.AnalysisPending) return "Approve Analysis";
    if (status == ScrapingStatus.SentimentPending) return "Approve Sentiment";
    if (status == ScrapingStatus.GeocodePending) return "Approve Geocoding";
    if (status == ScrapingStatus.SavePending) return "Approve Solr Update"

    return "Saved";
  }

  onToBeginningClick() {
    this.currentPage = 1;
    this.getRequestList()
  }

  calculateList(): number[] {
    this.displayRequestList = [];
    for (let i = (this.currentPage - 1) * this.pageSize; i < Math.min(this.requestList.length, (this.currentPage * this.pageSize)); i++) {
      this.displayRequestList.push(i);
    }

    return this.displayRequestList;
  }

  onPageSizeChange(event: any) {
    //console.log(event)
    //this.currentPage = Math.ceil(begin / event.value);
    this.currentPage = 1;
    this.getRequestList();
  }

  getSelectedList(treeNode: any): number {
    this.selectedRequestList = [];
    this.selectedAttemptList = [];
    if (!treeNode.length) return 0;
    for (let node of treeNode) {
      if (node.data.id == null) continue;
      const id = node.data.id;
      if (node.children) this.selectedRequestList.push(id);
      else this.selectedAttemptList.push(id);
    }
    return this.selectedRequestList.length + this.selectedAttemptList.length;
  }

  getRequestBegin() {
    return Math.min(((this.currentPage - 1) * this.pageSize), this.totalPage - 1);
  }

  getRequestEnd() {
    return Math.min(this.totalPage, this.getRequestBegin() + this.pageSize);
  }

  onBackClick() {
    this.currentPage = Math.floor(Math.max(1, this.currentPage - 1));
    this.getRequestList();
  }

  onNextClick() {
    this.currentPage = Math.min(this.currentPage + 1, Math.ceil(this.totalPage / this.pageSize));
    this.getRequestList();
  }

  onToLastClick() {
    this.currentPage = Math.ceil((this.totalPage / this.pageSize));
    this.getRequestList();
  }

  onCancelClick() {
    this.dialog_visible = false;
  }

  async onSaveClick() {
    if (this.scriptSelected.value.ScrapingScript) {
      this.confirmationService.confirm({
        message: 'Request Comfirmation',
        accept: async () => {
          let response: any;
          switch (this.scrapingTypeSelected.value) {
            case "News":
              response = await lastValueFrom(this.fastService.createNewsScrapingRequest(this.scriptSelected.value.ScrapingScript, this.paramForm.value));
              break;
            case this.scrapingTypes[1]:
              let data: any;
              switch (this.scriptSelected.value.GrantType) {
                case "AccessToken":
                  data = {
                    "grantType": "AccessToken",
                    "accessToken": this.accessToken
                  };
                  break;
                case "Password":
                  data = {
                    "grantType": "Password",
                    "username": this.username,
                    "password": this.password,
                  }
                  break;
                default:
                  data = {
                    "grantType": "NoRequire",
                  }
                  break;
              }
              data["scrapingScript"] = this.scriptSelected.value.ScrapingScript;
              response = await lastValueFrom(this.fastService.createSocialMediaScrapingRequests(data));
              break;
            default:
              break;
          }
          //await lastValueFrom(this.fastService.createScrapingRequest(this.scriptSelected, Number(this.scriptStartPage.value), Number(this.scriptStopPage.value)));
          this.messageService.add({ severity: response.status, summary: response.message })
          await this.getRequestList();
          this.dialog_visible = false;
        }
      })
    }
    else {
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: 'Please enter all the require fieilds.' })
    }


  }

  returnFetchIcon(request: WebScrapingRequest) {
    if (request.Status == 1) return this.loadingIcon;
    return this.fetchIcon;
  }

  returnViewIcon(status: number) {
    if (status < 2) {
      return this.viewBtnIcon;
    }
    else {
      return this.viewBtnActiveIcon;
    }
  }

  returnCheckIcon(status: number) {
    if (status % 2 == 1) return this.loadingIcon;
    if (status < ScrapingStatus.Geocoding) return this.fetchIcon;
    if (status == ScrapingStatus.SavePending) return this.checkBtnIcon;

    return this.checkBtnActiveIcon;
  }

  onPageChange(event: any) {
    // console.log(event);
  }

  onPageNumberClick() {
    this.gotoPage = this.currentPage;
    this.goto_dialog_visible = true;
  }

  getGotoOptions() {
    let options: number[] = [];
    for (let i = 1; i <= Math.ceil(this.totalPage / this.pageSize); i++) {
      options.push(i);
    }
    return options;
  }

  onGotoClick() {
    this.currentPage = this.gotoPage;
    this.goto_dialog_visible = false;
    this.getRequestList();
  }

  goto(page: number) {
    this.currentPage = page;
    this.getRequestList();
  }

  isActiveButton(page: number): boolean {
    let length = Math.ceil(this.totalPage / this.pageSize);

    if (page <= 0 || page > length) {
      return false;
    }

    if (page == this.currentPage - 4) {
      return this.currentPage == length;
    }

    if (page == this.currentPage - 3) {
      return this.currentPage + 1 >= length;
    }

    if (page == this.currentPage + 4) {
      return this.currentPage == 1;
    }

    if (page == this.currentPage + 3) {
      return this.currentPage <= 2;
    }

    return true;
  }

  getStatusClass(status: number) {
    switch (status) {
      case ScrapingStatus.FetchPending: return 'fetchPending';
      case ScrapingStatus.Fetching: return 'fetching';
      case ScrapingStatus.AnalysisPending: return 'analysisPending';
      case ScrapingStatus.Analyzing: return 'analyzing';
      case ScrapingStatus.SentimentPending: return ' sentimentPending';
      case ScrapingStatus.SentimentAnalyzing: return 'sentimentAnalyzing';
      case ScrapingStatus.GeocodePending: return 'geocodePending';
      case ScrapingStatus.Geocoding: return 'geocoding';
      case ScrapingStatus.SavePending: return 'savePending';
      case ScrapingStatus.Saving: return 'saving';
      case ScrapingStatus.Saved: return 'saved';
    }

    return ''
  }

  
  //Make treeNode
  treeNode: TreeNode[] = [];
  selectedTreeNode: TreeTableNode | TreeTableNode[] | null = [];
  getTreeNode() {
    let treeNodeTemp: TreeNode[] = [];
    //make root nodes

    for (let request of this.requestList) {
      let rootNode: TreeNode = {
        data: request,
        children: [],
      }
      rootNode.data.FoundQty = 0;
      rootNode.data.SavedQty = 0;
      rootNode.data.UpdatedQty = 0;
      rootNode.data.hasChildren = true;
      if (rootNode.data.Script) rootNode.data.ScrapingScript = rootNode.data.Script;

      for (let attempt of request.Attempts) {
        let node: TreeNode = {
          data: attempt
        }

        rootNode.children?.push(node);
        rootNode.data.FoundQty += node.data.FoundQty || 0;
        rootNode.data.SavedQty += node.data.SavedQty || 0;
        rootNode.data.UpdatedQty += node.data.UpdatedQty || 0;
      }

      for (let node of this.treeNode) {
        if (node.data._id == rootNode.data._id) {
          rootNode.expanded = node.expanded;
          break;
        }
      }
      treeNodeTemp.push(rootNode);
    }
    this.treeNode = treeNodeTemp;
    this.gettingRequest = false;
  }

  uploadedFiles: any;
  storeData: any;
  jsonData: any;
  worksheet: any;
  filefields: string[] = [];
  isDocx: boolean = false;

  uploadHandler(event: any) {
    if (this.scriptSelected.value && this.scriptSelected.value.Parameter) {
      for (let field of this.scriptSelected.value.Parameter) {
        this.newsFieldsVar[field.Name] = [];
      }
    }
    this.scriptSelected.setValue(null);
    this.uploadedFiles = event.files[0];

    const fileName: string = this.uploadedFiles.name;
    const fileType = fileName.split('.').pop();

    this.fastService.getFileScriptList(fileType ? fileType : '').subscribe((response: any) => {
      this.fileScriptList = response.response.data;
      // console.log(this.fileScriptList)
    })


    this.isDocx = fileType == "docx";

    if (this.isDocx) return;

    let readFile = new FileReader();
    readFile.onload = (e) => {
      this.storeData = readFile.result;
      var data = new Uint8Array(this.storeData);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      this.worksheet = workbook.Sheets[first_sheet_name];
      this.jsonData = XLSX.utils.sheet_to_json(this.worksheet, { raw: false });
      this.filefields = Object.keys(this.jsonData[0]);
      // console.log(this.filefields);
    }
    readFile.readAsArrayBuffer(this.uploadedFiles)
  }

  onRemove(event: any) {
    this.uploadedFiles = null;
    this.fileScriptList = [];
    this.isDocx = false;
    if (this.scriptSelected.value && this.scriptSelected.value.Parameter) {
      for (let field of this.scriptSelected.value.Parameter) {
        this.newsFieldsVar[field.Name] = [];
      }
    }
  }

  onFileSaveClick() {
    if (!this.uploadedFiles || !this.scriptSelected.value.Name) return;

    let data: FormData = new FormData();
    data.append('ScrapingScript', this.scriptSelected.value.Name);
    for (let field of this.scriptSelected.value.Parameter) {
      if (this.newsFieldsVar[field.Name]) data.append(field.Name, this.newsFieldsVar[field.Name].join(', '));
    }
    data.append('File', this.uploadedFiles, this.uploadedFiles.name)

    this.fastService.uploadFile(data).subscribe((response: any) => this.messageService.add({ severity: response.status, summary: response.status.toUpperCase(), detail: response.message }));

    this.getRequestList();
    this.dialog_visible = false;
  }

  getParam(name: string) {
    const lowerName = name.toLowerCase();
    return this.scriptSelected.value?.Parameter?.find(
      (p: any) => p.Name?.toLowerCase() === lowerName
    ) || {};
  }

  getParamRequire(name: string) {
    if (this.getParam(name).require === undefined) return false;
    return this.getParam(name).require;
  }

  getParamLabel(name: string) {
    const param = this.getParam(name);
    return param?.Label || name;
  }

  shouldShowDescription(): boolean {
    if (this.isEmpty(this.scriptSelected.value) || this.scrapingTypeSelected.value != this.scrapingTypes[0]) return false;
    const param = this.getParam('description');
    if (param.require === false) {
      return false
    }
    return true;
  }

  isEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }


}


export class WebScrapingRequest {
  RequestID: string = "";
  ScrapingScript: string = "";
  ScrapingType: string = "";
  Date: string = "";
  Status: number = 0;
  CurrentAttempt: string = "";
  StartPage: number = 0;
  StopPage: number = 0;
  AccessToken: string = "";
  isRequireAuth: boolean = true;
  Attempts: WebScrapingAttempt[] = [];
  TotalQty: number = 0;
  Script: string = "";
}

export class WebScrapingAttempt {
  Date: string = "";
  Quantity: number = 0;
  FoundQty: number = 0;
  SavedQty: number = 0;
  UpdatedQty: number = 0;
  Status: number = 0;
  AttemptID: string = "";
}

export class NewsFields {
  [key: string]: string[];
}